var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRankPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6254 28H10.5039C9.29641 28 8.31641 28.9783 8.31641 30.1875V52.0555C8.31641 53.263 9.29466 54.243 10.5039 54.243H25.8112V30.1875C25.8112 28.98 24.8347 28 23.6254 28ZM34.5594 14.8785H21.4379C20.2304 14.8785 19.2504 15.8568 19.2504 17.066V26.9063H23.6237C25.4349 26.908 26.9014 28.3763 26.9032 30.1858V54.2413H36.7434V17.0643C36.7434 15.8568 35.7687 14.8785 34.5594 14.8785ZM47.6809 3.94454V52.0555C47.6809 53.263 46.7027 54.243 45.4934 54.243H37.8389V17.066C37.8372 15.2548 36.3689 13.7883 34.5594 13.7865H30.1862V3.94629C30.1862 2.73879 31.1644 1.75879 32.3737 1.75879H45.4952C46.7027 1.75879 47.6809 2.73529 47.6809 3.94454Z",
    fill: "#B3D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6805 3.94454V52.0555C47.6805 53.263 46.7022 54.243 45.493 54.243H37.8385V17.066C37.8367 15.2548 36.3685 13.7883 34.559 13.7865H30.1857V3.94629C30.1857 2.73879 31.164 1.75879 32.3732 1.75879H45.4947C46.7022 1.75879 47.6805 2.73529 47.6805 3.94454Z",
    fill: "#5D89EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankPromotion);
export default __webpack_public_path__ + "static/media/rank-promotion.96cfc2d4.svg";
export { ForwardRef as ReactComponent };